import { ThunderboltFilled, ThunderboltOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';

import { DoubleThunderbolt } from 'app/components/commons/DoubleThunderbolt/DoubleThunderbolt';

import '../Cells.scss';

import './CellIcon.scss';

export enum CellIconType {
  AutoInventory = 'AutoInventory',
  PricingRule = 'PricingRule',
}

export enum CellIconColor {
  Blue = 'Blue',
  Grey = 'Grey',
}

export type CellIconProps = {
  showIcon: boolean;
  iconType: CellIconType;
  iconColor: CellIconColor;
  autoCell: boolean;
  openingInLastMinuteAutoDiscountRange?: boolean;
};

export const CellIcon = ({
  showIcon,
  iconType,
  iconColor,
  autoCell,
  openingInLastMinuteAutoDiscountRange,
}: CellIconProps) => {
  if (!showIcon) {
    return null;
  }

  const colorClassName = `cell-icon__${
    iconColor === CellIconColor.Blue ? 'blue-icon' : 'grey-icon'
  }`;

  const renderIcon = () => {
    let tooltipTitle = '';
    let icon: React.ReactNode = null;

    switch (iconType) {
      case CellIconType.AutoInventory:
        if (autoCell) {
          tooltipTitle = 'Auto inventory activated';
          icon = (
            <div className={classNames(colorClassName, 'cell-icon__plein-dot')}>
              •
            </div>
          );
        } else if (!autoCell) {
          tooltipTitle = 'Auto inventory deactivated by manual edition';
          icon = (
            <div className={classNames(colorClassName, 'cell-icon__empty-dot')}>
              ○
            </div>
          );
        }

        break;

      case CellIconType.PricingRule:
        if (autoCell && openingInLastMinuteAutoDiscountRange) {
          tooltipTitle = 'Last minute discount activated';
          icon = (
            <span className={colorClassName}>
              <DoubleThunderbolt />
            </span>
          );
        } else if (autoCell) {
          tooltipTitle = 'Default discount activated';
          icon = (
            <span className={colorClassName}>
              <ThunderboltFilled />
            </span>
          );
        } else {
          tooltipTitle = 'Default discount deactivated by manual edition';
          icon = (
            <span className={colorClassName}>
              <ThunderboltOutlined />
            </span>
          );
        }

        break;
    }

    return { icon, tooltipTitle };
  };

  const { icon, tooltipTitle } = renderIcon();

  return icon ? (
    <Tooltip
      className="cell-icon__container"
      placement="bottom"
      title={tooltipTitle}
      arrowPointAtCenter
    >
      {icon}
    </Tooltip>
  ) : null;
};
